import styles from './S03.module.css';
import Commissioner from '../Cards/Commissioner';
import data from './commissioners.json';


export default function S03(){

  return <div className={styles.main}>
  {data.commissioners.map((item, i) => <Commissioner data={item} key={"commisioner" + i}/>)}
  </div>;
}
